<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新增管理</el-breadcrumb-item>
        <el-breadcrumb-item>库存管理</el-breadcrumb-item>
        <el-breadcrumb-item>库存管理看板</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row :gutter="24">
      <el-col :span="24">
        <el-card class="box-card">
          <div class="card_title">本月销售明细---列表</div>
          <!-- 筛选条件 start -->
          <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
            <el-form-item label="统计日期">
              <el-date-picker v-model="keywords.riqi" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="clickSearch">查询</el-button>
            </el-form-item>
          </el-form>
          <!-- 筛选条件 end -->
          <!-- 数据列表 start -->
          <el-table :data="KuCunList" ref="KuCunList" :row-class-name="tableRowClassName" :cell-style="{padding: '0'}" border height="360">
            <el-table-column prop="Name" label="项目名称" width="300"></el-table-column>
            <el-table-column prop="InNum" label="入库" width="150"></el-table-column>
            <el-table-column prop="OutNum" label="出库" width="150"></el-table-column>
            <el-table-column prop="KuCunNum" label="库存" width="150"></el-table-column>
            <el-table-column prop="YuJingNum" label="预警数量" width="150"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">本月产品退货汇总表</div>
          <!-- 数据列表 start -->
          <el-table :data="TuiHuoChanPingList" ref="TuiHuoChanPingList" :row-class-name="tableRowClassName" :cell-style="{padding: '0'}" border height="360">
            <el-table-column prop="Name" label="品名" min-width="25%"></el-table-column>
            <el-table-column prop="InNum" label="退货入库" min-width="25%"></el-table-column>
            <el-table-column prop="OutNum" label="退货出库" min-width="25%"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">本月物料退货汇总表</div>
          <!-- 数据列表 start -->
          <el-table :data="TuiHuoWuLiaoList" ref="TuiHuoWuLiaoList" :row-class-name="tableRowClassName" :cell-style="{padding: '0'}" border height="360">
            <el-table-column prop="Name" label="品名" min-width="25%"></el-table-column>
            <el-table-column prop="InNum" label="退货入库" min-width="25%"></el-table-column>
            <el-table-column prop="OutNum" label="退货出库" min-width="25%"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyErp6InventorySignboard',
  data () {
    return {
      keywords: {
        riqi: '',
      },
      KuCunList:[],
      TuiHuoChanPingList:[],
      TuiHuoWuLiaoList:[]
    }
  },
  mounted () {
    this.keywords.riqi = Vue.prototype.FunGetTimeStringShort()
    this.apiErp6InventorySignboard()
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if(row.Name == '合计'){
        return 'success-row';
      }
      return '';
    },
    clickSearch () {
      this.apiErp6InventorySignboard()
    },
    apiErp6InventorySignboard: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        riqi: that.keywords.riqi
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Erp6InventorySignboard, Qs.stringify(data))
        .then(function (response) {
          console.log(response.data)
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.KuCunList = response.data.KuCunList
          that.TuiHuoChanPingList = response.data.TuiHuoChanPingList
          that.TuiHuoWuLiaoList = response.data.TuiHuoWuLiaoList
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

</style>

<style lang="less" scoped>
.box-card{
    margin-top: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#999;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
    }
}

.warntitle{
    //display: flex;
    align-items: center;
    color:#ff0000;
    font-size: 30px;
    margin: 0;
    font-weight: bold;
    text-decoration:underline;
    text-align:center;
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}

</style>
